import DateTime from "../../Components/DateTime";
import React, { useState, useEffect, useContext, useRef } from "react";
import PageTabs from "../../Components/PageTabs";
import MainButton from "../../Props/MainButton";
import TemplateSettingApi from "../../../API/APIServices/TemplateSetting";
import AlertBox from "../../Props/AlertBox";
import MyContext from "../../MyContext";
import ModelReportFor from "./ModelReportFor";
import CsvDownload from "./CsvDownload";
import ImportCsv from "./ImportCsv";

import PropTypes from "prop-types";
import { formatDate } from "date-fns";

function ReportTemplateSetting({
  fetchData,
  setSliderCallBack,
  editData,
  modelOpen,
}) {
  ReportTemplateSetting.propTypes = {
    fetchData: PropTypes.func.isRequired,
    setSliderCallBack: PropTypes.func.isRequired,
    editData: PropTypes.object,
    modelOpen: PropTypes.bool.isRequired,
  };
  const [columnfilter, setcolumnfilter] = useState({
    filter1: {
      column1: null,
      column2: null,
    },
    filter2: {
      column1: null,
      column2: null,
    },
    filter3: {
      column1: null,
      column2: null,
    },
    filter4: {
      column1: null,
      column2: null,
    },
    filter5: {
      column1: null,
      column2: null,
    },
  });
  const [checkedItem, setCheckedItem] = useState([]);
  const [, setLoading] = useState(false);
  const {
    OpenAlertBox,
    alertBox,
    OpenAlertBoxEdit,
    alertBoxEdit,
    alertBoxDelete,
    OpenAlertBoxDelete,
  } = useContext(MyContext);
  const [FieldValue, SetFieldValue] = useState([
    { value: "0", name: "--Select--" },
    { value: "89", name: "Status Master" },
    { value: "45", name: "Agent Master" },
    {
      value: "1",
      name: "Auto Suggetion Account Group",
    },
    {
      value: "2",
      name: "Auto Suggetion Account Master",
    },
    { value: "3", name: "Auto Suggetion Item Group" },
    { value: "4", name: "Auto Suggetion Item Master" },
  ]);

  const [FieldName, setFieldName] = useState([
    "Show/Hide",
    "Column Name",
    "Data Type",
    "Column Name By User",
    "Show Total Value",
    "Select Box With Save Button",
    "Priority",
  ]);

  /***********title***************/
  useState(() => {
    document.title = "Report Template Setting";
  }, []);

  //**********{control modal box 1}*****************//

  //*****************{modal box}*****************//
  const [, setModalOpen] = useState(false);
  const showModal = () => {
    setModalOpen(true);
  };

  /************Category box****************/

  const [rows, setRows] = useState([]);

  const handleAddRow = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        columnName: `Column${prevRows.length + 1}`,
        otherData: `Data${prevRows.length + 1}`,
      },
    ]);
  };

  const [options, setOptions] = useState([]);

  const handleMasterIdChange = (newMasterId) => {
    ;
    // Update the selected value
    setOptions(newMasterId);
    setInputValues((prevValues) => ({
      ...prevValues,
      reportAttachTo: newMasterId,
    }));
  };

  const fetchData1 = async () => {
    try {
      const response = await TemplateSettingApi.getAllMasterType();
      if (response && Array.isArray(response)) {
        setOptions(response.map((item) => ({ id: item.id, name: item.name })));
      } else {
        console.error("Error:", response.errorMessages);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData1();
  }, []);

  const cleanQuery = (query) => {
    return query.replace(/\n/g, " ").replace(/\s+/g, " ").trim();
  };

  const DB1 = [
    "MainUnit",
    "AltUnit",
    "UnitConvFactor",
    "IsService",
    "ChangeApplyFromDate",
    "Tax1",
    "Tax1Range",
    "Tax2",
    "EnableBarcode",
    "DefaultBarcode",
    "SaleDiscPer",
    "PurDiscPer",
    "HSNCode",
    "LoyaltyPoint",
    "ItemIncentiveSalesman",
    "AlertNegativeQty",
    "RestrictNegativeQty",
    "TaxOnMrp",
    "CGST",
    "SGST",
    "IGST",
    "CESS",
    "Remarks",
    "BranchId",
  ];
  const DBboth = [
    "Name",
    "PrintName",
    "Alias",
    "PrimaryGroup",
    "ParentGrp",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
  ];
  const [ColumnNames, setColumnNames] = useState([]);
  function getTodayDate() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  const handleFormSubmit = async (event) => {
    ;
    event.preventDefault();

    // Get the values from the input fields
    const q1 = cleanQuery(inputValues.queryForSql.trim());
    const q2 = cleanQuery(inputValues.queryForMySQL.trim());
    const q3 = cleanQuery(inputValues.queryForSqlite.trim());

    if (inputValues.reportName.length == 0) {
      alert("Please write report name");
      return;
    }

    if (inputValues.reportAttachTo.length == 0) {
      alert("Please select report for");
      return;
    }

    if (inputValues.reportType.length == 0) {
      alert("Please select report type");
      return;
    }

    // Validate query input
    if (!q1 && !q2 && !q3) {
      alert("Please enter at least one query.");
      return;
    }
    if (!q1) {
      alert("SQL query box is empty.");
      return;
    }
    if (!q2) {
      alert("MySQL query box is empty.");
      return;
    }
    if (!q3) {
      alert("SQLite query box is empty.");
      return;
    }

    try {
      let query1 = q1;
      let query2 = q2;
      let query3 = q3;

      if (inputValues.reportAttachTo == 63) {
        query1 = query1.replace(/{{AccId}}/g, 0);
        query1 = query1.replace(/{{Date1}}/g, getTodayDate());
        query1 = query1.replace(/{{Date2}}/g, getTodayDate());


        query2 = query2.replace(/{{AccId}}/g, 0);
        query2 = query2.replace(/{{Date1}}/g, getTodayDate());
        query1 = query1.replace(/{{Date2}}/g, getTodayDate());


        query3 = query3.replace(/{{AccId}}/g, 0);
        query3 = query3.replace(/{{Date1}}/g, getTodayDate());
        query1 = query1.replace(/{{Date2}}/g, getTodayDate());


      }
      const response = await TemplateSettingApi.getQueryColumnName(query1, query2, query3);
      console.log(response);

      if (response) {
        Object.keys(response).map((item, index) => {
          setCheckedItem((prev) => [...prev, index]);
        });

        const newColumnNames = response;
        setColumnNames(newColumnNames);
        ;
        function CheckDB(FieldName) {
          ;
          if (DB1.includes(FieldName)) {
            return "1";
          }
          if (DBboth.includes(FieldName)) {
            return "3";
          }
          return "2";
        }

        const tempFormData = { ...formData };

        const existingColumnNames = new Set(
          tempFormData.rows.map((row) => row.columnName)
        );

        console.log(existingColumnNames);
        const updatedRows = [];

        tempFormData.rows.forEach((row) => {
          if (Object.keys(newColumnNames)?.includes(row.columnName)) {
            updatedRows.push(row);
          }
        });

          console.log("newcolumnname", newColumnNames);

          Object.keys(newColumnNames).forEach((columnName) => {
            console.log(columnName);
            if (!existingColumnNames.has(columnName)) {
              updatedRows.push({
                showOrHide: true,
                columnName: columnName,
                columnDataType: newColumnNames[columnName],
                columnNameByUser: columnName,
                columnShowTotalValue: false,
                // columnSelectBoxWithSaveBtn: CheckDB(columnName),
                columnSelectBoxWithSaveBtn: "0",
                col1: updatedRows.length + 1,
                col2: "",
                col3: "",
                col4: "",
                Sub_Query: "",
                DBVAlue: CheckDB(columnName),
              });
            }
          });

        checkIfAllFieldsPresent(updatedRows, inputValues.rowWise_Print);
        setFormData({ rows: updatedRows });


        // setFormData((prev) => {
        //   const existingColumnNames = new Set(
        //     prev.rows.map((row) => row.columnName)
        //   );
        //   console.log(existingColumnNames);
        //   const updatedRows = [];

        //   prev.rows.forEach((row) => {
        //     if (Object.keys(newColumnNames)?.includes(row.columnName)) {
        //       updatedRows.push(row);
        //     }
        //   });

        //   console.log("newcolumnname", newColumnNames);

        //   Object.keys(newColumnNames).forEach((columnName) => {
        //     console.log(columnName);
        //     if (!existingColumnNames.has(columnName)) {
        //       updatedRows.push({
        //         showOrHide: true,
        //         columnName: columnName,
        //         columnDataType: newColumnNames[columnName],
        //         columnNameByUser: columnName,
        //         columnShowTotalValue: false,
        //         columnSelectBoxWithSaveBtn: CheckDB(columnName),
        //         col1: columnName,
        //         col2: "",
        //         col3: "",
        //         col4: "",
        //         Sub_Query: "",
        //         DBVAlue: CheckDB(columnName),
        //       });
        //     }
        //   });

        //   return { rows: updatedRows };
        // });


      } else {
        console.error("Unexpected API response format:", response);
      }

      if (inputValues.reportType == "3") {
        SetFieldValue([
          {
            value: "",
            name: "--Select DB--",
          },
          {
            value: "1",
            name: "DB1",
          },
          {
            value: "2",
            name: "DB2",
          },
          {
            value: "3",
            name: "Both",
          },
        ]);

        setFieldName([
          "Show/Hide",
          "Column Name",
          "Data Type",
          "Sub-Query",
          "Column Name By User",
          "Apply Query",
          // "Param Key",
          "Select Database",
          "Priority",
        ]);
        setshowImportDonwload(true);
      } else {
        SetFieldValue([
          { value: "", name: "--Select--" },
          { value: "89", name: "Status Master" },
          { value: "45", name: "Agent Master" },
          {
            value: "1",
            name: "Auto Suggetion Account Group",
          },
          {
            value: "2",
            name: "Auto Suggetion Account Master",
          },
          { value: "3", name: "Auto Suggetion Item Group" },
          { value: "4", name: "Auto Suggetion Item Master" },
        ]);
        setFieldName([
          "Show/Hide",
          "Column Name",
          "Data Type",
          "Column Name By User",
          "Show Total Value",
          "Select Box With Save Button",
          "Priority",
        ]);
        setshowImportDonwload(false);
      }
    } catch (error) {
      console.error("Error executing query:", error);
    }
  };

  console.log("checked ", checkedItem);

  useEffect(() => {
    console.log("checkitem", checkedItem);
  }, [checkedItem]);

  const [activeTab, setActiveTab] = useState(0); // Initialize the active tab index

  // const [QueryinputValues, setQueryInputValues] = useState({
  //     queryForSql: '',
  //     queryForMySQL: '',
  //     queryForSqlite: ''
  // });
  const [showfillbtn, setShowfillbtn] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const handleClickfillquery = (e) => {
    e.preventDefault();
    setShowMessage(true);
    const { queryForMySQL, queryForSql, queryForSqlite, eF1, eF2 } =
      inputValues;
    console.log(queryForMySQL, queryForSqlite, queryForSql);

    if (queryForSql.length > 0) {
      setInputValues((prev) => ({
        ...prev,
        queryForSql: queryForSql,
        queryForMySQL: queryForSql,
        queryForSqlite: queryForSql,
        eF1: eF1,
        eF2: eF2,
      }));
    } else if (queryForMySQL.length > 0) {
      setInputValues((prev) => ({
        ...prev,
        queryForSql: queryForMySQL,
        queryForMySQL: queryForMySQL,
        queryForSqlite: queryForMySQL,
        eF1: eF1,
        eF2: eF2,
      }));
    } else if (queryForSqlite.length > 0) {
      setInputValues((prev) => ({
        ...prev,
        queryForSql: queryForSqlite,
        queryForMySQL: queryForSqlite,
        queryForSqlite: queryForSqlite,
        eF1: eF1,
        eF2: eF2,
      }));
    }
    setTimeout(() => {
      setShowMessage(false);
    }, 3000);
  };

  const [NextPageColumn, setNextPageColumn] = useState([]);
  const handleNextPageColumn = async (e) => {
    try {
      ;
      inputValues.eF3 = e.target.value;
      const filter = [
        {
          fieldName: "reportAttachTo",
          operatorName: "equal",
          compareValue: inputValues.eF3,
        },
      ];
      const data = await TemplateSettingApi.getTemplateSettingFilter(filter);
      console.log(data);
      setNextPageColumn(data[0].templateSettingReportConfigList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    if (index !== 7) {
      var firstTabElement = document.getElementById("firstTab");
      firstTabElement.classList.remove("active1");
      console.log(index);
    }
  };

  //  /* *******************Tab****************** */

  const [tabcontent1, setTabContent1] = useState(true);
  const [tabcontent2, setTabContent2] = useState(false);
  const [tabcontent3, setTabContent3] = useState(false);

  const showtabs1 = () => {
    setTabContent1(true);
    setTabContent2(false);
    setTabContent3(false);
  };

  const showtabs2 = () => {
    setTabContent1(false);
    setTabContent2(true);
    setTabContent3(false);
  };

  const showtabs3 = () => {
    setTabContent1(false);
    setTabContent2(false);
    setTabContent3(true);
  };

  const [CSVModalOpen, setCSVModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleOptionClick = (option) => {
    ;
    setSelectedOption(option);
    setIsOpen(false);
  };

  //**********show hide*****************//
  const handleCheckboxChangeDrop = (option) => {

    if("rowWise_Print" == option){

      const isRowWisePrintChecked = !inputValues["rowWise_Print"];
      
        checkIfAllFieldsPresent(formData.rows, isRowWisePrintChecked);
    }


    setInputValues((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };
  const handleNavigationChange = (e) => {
    ;
    // if(e="eF4"){
    //   const StringD = JSON.stringify(columnfilter)
    //   const encode  = encodeURIComponent(StringD)
    //   console.log("encode",encode);

    //   return setInputValues((prev)=>({
    //     ...prev,
    //     eF4:encode
    //   }))
    // }
    const { name, value } = e.target;
    setInputValues((prev) => ({
      ...prev,
      [name]: e.target.value,
    }));
  };

  const handlecolumnfilter = (e) => {
    ;
    if ((e = "eF4")) {
      const StringD = JSON.stringify(columnfilter);
      const encode = encodeURIComponent(StringD);
      console.log("encode", encode);

      return setInputValues((prev) => ({
        ...prev,
        eF4: encode,
      }));
    }
  };

  const handleCurrentPageColumn = (e, filter, column) => {
    const { value } = e.target;
    setcolumnfilter((prev) => ({
      ...prev,
      [filter]: {
        ...prev[filter],
        [column]: value,
      },
    }));
  };

  useEffect(() => {
    console.log(`columnfilter`, columnfilter);
    handlecolumnfilter("eF4");
  }, [columnfilter]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown if clicked outside
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /***********End Enter code*****************/

  // const input1Ref = useRef(null);
  // const input2Ref = useRef(null);

  // const handleKeyPress = (event, nextInputRef) => {
  //     if (event.key === 'Enter') {
  //         event.preventDefault();
  //         nextInputRef.current.focus();
  //     }
  // };

  // Handle form submission

  /****************************************************** */

  const [errorMessages, setErrorMessages] = useState({
    reportName: "",
    reportType: "",
    reportAttachTo: "",
    pagination: "",
  });

  const [inputValues, setInputValues] = useState({
    reportName: "",
    queryForSql: "",
    queryForSqlite: "",
    queryForMySQL: "",
    reportAttachTo: "",
    pageLink: "",
    reportType: "",
    pagination: "",
    search_ByDate: "",
    search_AnyText: "",
    search_ByColumn: "",
    // pagination: '',
    orderByButton: "",
    firmNameSelect: "",
    transactionTypeSelect: "",
    billSeriesNameSelect: "",
    printButton: "",
    excelButton: "",
    shareButton: "",
    rowWise_Edit: "",
    rowWise_Print: "",
    rowWise_Whatsapp: "",
    rowWise_Delete: "",
    rowWise_ArrowForOtherPage: "",
    rowWise_TransporterOrOther: "",
    srch1: "",
    srch2: "",
    srch3: "",
    srch4: "",
    eF1: "",
    eF2: "",
    eF3: "",
    eF4: "",
    isActive: true,
  });

  useEffect(() => {
    console.log("inputValues", inputValues);
  }, [inputValues]);

  const [formData, setFormData] = useState({
    rows: rows.map((data) => ({
      showOrHide: true,
      columnName: data.columnName,
      columnDataType: "",
      columnNameByUser: "",
      columnShowTotalValue: false,
      columnSelectBoxWithSaveBtn: "",
      col1: "",
      col2: "",
      col3: "",
      col4: "",
      DBVAlue: "",
      Sub_Query: "",
      isDisabled: true,
    })),
  });
  console.log(formData);

  const [error, setError] = useState("");

  // console.log(formData);

  const [showImportDonwload, setshowImportDonwload] = useState(false);
  const handleInputChange = (event) => {
    ;
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);
    if (value == "3" || value == "Import Export Type") {
      setFieldName([
        "Show/Hide",
        "Column Name",
        "Data Type",
        "Sub-Query",
        "Column Name By User",
        "Apply Query",
        // "Param Key",
        "Select Database",
        "Priority",
      ]);

      SetFieldValue([
        {
          value: "",
          name: "--Select DB--",
        },
        {
          value: "1",
          name: "DB1",
        },
        {
          value: "2",
          name: "DB2",
        },
        {
          value: "3",
          name: "Both",
        },
      ]);
      setshowImportDonwload(true);
    } else {
      setFieldName([
        "Show/Hide",
        "Column Name",
        "Data Type",
        "Column Name By User",
        "Show Total Value",
        "Select Box With Save Button",
        "Priority",
      ]);

      SetFieldValue([
        { value: "", name: "--Select--" },
        { value: "89", name: "Status Master" },
        { value: "45", name: "Agent Master" },
        {
          value: "1",
          name: "Auto Suggetion Account Group",
        },
        {
          value: "2",
          name: "Auto Suggetion Account Master",
        },
        { value: "3", name: "Auto Suggetion Item Group" },
        { value: "4", name: "Auto Suggetion Item Master" },
      ]);
      setshowImportDonwload(false);
    }
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [name]: value,
    }));
    setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  // const [checkedItem, setCheckedItem] = useState([])
  // const handleCheckboxChange = (rowIndex, checkboxType) => (event) => {
  //     const { checked } = event.target;
  //     
  //     if (checked) {
  //         setCheckedItem((prev) => [...prev, rowIndex])
  //     }

  //     if (!checked) {
  //         setCheckedItem(prev => prev = [prev.filter((item) => item !== rowIndex)])
  //     }

  //     setFormData(prev => {
  //         const updatedRows = [...prev.rows];
  //         updatedRows[rowIndex] = {
  //             ...updatedRows[rowIndex],
  //             [checkboxType]: checked
  //         };
  //         return { rows: updatedRows };
  //     });
  //     console.log(checkedItem)
  // };
  // console.log(setFormData);

  // const handleMasterCheckboxChange = (event) => {
  //     const isChecked = event.target.checked;
  //     setCheckedItem(isChecked ? formData.rows.map((_, index) => index) : []);

  //     // Update all rows' showOrHide property based on the master checkbox state
  //     formData.rows.forEach((row, index) => {
  //         row.showOrHide = isChecked;
  //     });
  // };

  // const handleCheckboxChange = (index, field) => (event) => {
  //     const isChecked = event.target.checked;
  //     const updatedCheckedItem = isChecked
  //         ? [...checkedItem, index]
  //         : checkedItem.filter(item => item !== index);

  //     setCheckedItem(updatedCheckedItem);

  //     // Update the specific row's property
  //     formData.rows[index][field] = isChecked;
  // };

  const handleCheckboxChangeWrapper = (index, field) => (event) => {
    ;
    const isChecked = event.target.checked;

    // Update the checked items array
    if (isChecked) {
      setCheckedItem((prevCheckedItem) => [...prevCheckedItem, index]);
    } else {
      setCheckedItem((prevCheckedItem) =>
        prevCheckedItem.filter((item) => item !== index)
      );
      console.log(checkedItem);
    }

    // setFormData(prev => {
    //     const updatedRows = [...prev.rows];
    //     updatedRows[rowIndex] = {
    //         ...updatedRows[rowIndex],
    //         [checkboxType]: checked
    //     };
    //     return { rows: updatedRows };
    // });

    // Assuming you're also updating the row's state
    formData.rows[index][field] = isChecked;
  };

  const handleFormData = (rowIndex, field) => (event) => {
    event.stopPropagation();

    const value = event.target.value;

    console.log(rows.Sub_Query);

    // Update form data
    setFormData((prev) => {
      const updatedRows = [...prev.rows];
      updatedRows[rowIndex] = { ...updatedRows[rowIndex], [field]: value };

      if (field === "columnDataType") {
        const isIntegerOrFloat = value === "Integer" || value === "Float";
        updatedRows[rowIndex].isDisabled = !isIntegerOrFloat;

        if (!isIntegerOrFloat) {
          // alert("Please select Integer or Float to enable the checkbox.");
          updatedRows[rowIndex].columnShowTotalValue = false;
        }
      }

      return { rows: updatedRows };
    });
  };


  function checkIfAllFieldsPresent(fieldRows, isShowRowPrintCheck) {

    const MasterType = inputValues.reportAttachTo;

    const masterReportFormate1MasterTypes = [1, 2, 3, 4, 6, 8, 10, 11, 34, 45, 69, 82, 84];

    let isPresentInMasterListReport1 = masterReportFormate1MasterTypes.find(type => type == MasterType);

    isPresentInMasterListReport1 = isPresentInMasterListReport1 === undefined ? false : true;

    let requiredFields = [];

    if (isPresentInMasterListReport1) {

      let requiredFieldsMasterReportFormat = [

        { columnName: "Id", isPresent: false },
        //{ columnName: "d1RefId", isPresent: false },
        { columnName: "TotalRecords", isPresent: false },
        //{ columnName: "MasterType", isPresent: false },
      ];

      if (MasterType == 4) {
        requiredFieldsMasterReportFormat.push({ columnName: "ProductCategory", isPresent: false });
      }

      requiredFields = requiredFieldsMasterReportFormat;

    }

    const masterReportFormate2MasterTypes = [12, 13, 14, 15, 48, 53, 55, 57, 70, 71, 72, 73, 
      371, 372, 373, 374, 375, 376, 377, 378];

    let isPresentInMasterListReport2 = masterReportFormate2MasterTypes.find(type => type == MasterType);

    if (isPresentInMasterListReport2) {

      let requiredFieldsMasterReportFormat2 = [

        { columnName: "Id", isPresent: false },
        { columnName: "MasterType", isPresent: false },
        { columnName: "VoucherSeriesId", isPresent: false },
        { columnName: "VouchDate", isPresent: false },
        //{ columnName: "StatusName", isPresent: false },
        //{ columnName: "TotalBalanceQty", isPresent: false },
        //{ columnName: "TransId", isPresent: false },
        //{ columnName: "PartyName", isPresent: false },
        //{ columnName: "BillAmt", isPresent: false },
        // { columnName: "VouchNo", isPresent: false },
        { columnName: "TotalRecords", isPresent: false },
        
      ];

      if(MasterType === 55 || MasterType === 281) {

        requiredFieldsMasterReportFormat2.push({ columnName: "TransId", isPresent: false });
      }

      if (isShowRowPrintCheck) {

        // requiredFieldsMasterReportFormat2.push({ columnName: "VoucherSeriesId", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "MobileNo", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "Email", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "BillStatusId", isPresent: false });

      }


      if (MasterType == 53) {

        requiredFieldsMasterReportFormat2.push({ columnName: "Trans1IdT1", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "TransTypeT1", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "DBIdT1", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "Trans1IdT2", isPresent: false });
        requiredFieldsMasterReportFormat2.push({ columnName: "StatusId", isPresent: false });
      }

      requiredFields = requiredFieldsMasterReportFormat2;

    }


    fieldRows.forEach((row, index) => {

      const columnInLowercase = row.columnName?.toLowerCase();

      for (let i = 0; i < requiredFields.length; i++) {
        if (columnInLowercase === requiredFields[i].columnName?.toLowerCase()) {
          requiredFields[i].isPresent = true;
        }
      }
    });

    const missingFields = requiredFields.filter(
      (field) => !field.isPresent
    ).map((field) => field.columnName);

    let missingFieldsString = missingFields.join(", ");

    let errorMessage = `Missing required fields: ${missingFieldsString}`;

    if (missingFields.length > 0) {
      setError(errorMessage);
    } else {
      setError("");
    }

  }


  const SaveBtn = async () => {
    ;
    // let allValid = true;
    // fieldNames.forEach((fieldName) => {
    //     const isValid = validateInput(fieldName);
    //     if (!isValid) {
    //         allValid = false;
    //     }
    // });
    if (true) {
      setLoading(true);
      ;
      if (Boolean(modelOpen) === true) {
        const isSuccess = await TemplateSettingApi.updateTemplateSetting(
          inputValues,
          formData
        ).catch((err) => console.log(err));
        if (isSuccess) {
          OpenAlertBoxEdit();
          fetchData();
          setLoading(false);
          setSliderCallBack(false);
          // window.location.reload();
        } else {
          alert("error while updating");
        }
      } else {
        setLoading(true);
        const isSuccess = await TemplateSettingApi.insertTemplateSetting(
          inputValues,
          formData
        );
        if (isSuccess) {
          // fetchData();
          // fetchData()
          setLoading(false);
          OpenAlertBox();
        } else {
          alert("Error inserting data");
        }
      }
      // props.fetchData()
      setInputValues({
        reportName: "",
        queryForSql: "",
        queryForSqlite: "",
        queryForMySQL: "",
        reportAttachTo: "",
        pageLink: "",
        reportType: "",
        pagination: "",
        search_ByDate: "",
        search_AnyText: "",
        search_ByColumn: "",
        pagination: "",
        orderByButton: "",
        firmNameSelect: "",
        transactionTypeSelect: "",
        billSeriesNameSelect: "",
        printButton: "",
        excelButton: "",
        shareButton: "",
        rowWise_Edit: "",
        rowWise_Print: "",
        rowWise_Whatsapp: "",
        rowWise_Delete: "",
        rowWise_ArrowForOtherPage: "",
        rowWise_TransporterOrOther: "",
        srch1: "",
        srch2: "",
        srch3: "",
        srch4: "",
        eF1: "",
        eF2: "",
      });

      setFormData({
        rows: rows.map((data, index) => ({
          showOrHide: false,
          columnName: data.columnName,
          columnDataType: "",
          columnNameByUser: "",
          columnShowTotalValue: false,
          columnSelectBoxWithSaveBtn: "",
          col1: index+1,
          col2: "",
          col3: "",
          col4: "",
          Sub_Query: "",
        })),
      });
    }
  };

  useEffect(() => {
    const fetchData = () => {
      if (editData) {
        try {
          ;
          const data = editData;
          console.log(data);
          setInputValues(data.templateSettingDTO ?? {});
          if (data.templateSettingDTO.reportType == 3) {
            setFieldName([
              "Show/Hide",
              "Column Name",
              "Data Type",
              "Sub-Query",
              "Column Name By User",
              "Apply Query",
              // "Param Key",
              "Select Database",
              "Priority",
            ]);

            SetFieldValue([
              {
                value: "",
                name: "--Select DB--",
              },
              {
                value: "1",
                name: "DB1",
              },
              {
                value: "2",
                name: "DB2",
              },
              {
                value: "3",
                name: "Both",
              },
            ]);
            setshowImportDonwload(true);
          } else {
            setshowImportDonwload(false);
          }
          data.templateSettingReportConfigList.map((item, index) => {
            setCheckedItem((prev) => [...prev, index]);
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    editData != undefined && fetchData();
  }, [editData]);

  useEffect(() => {
    ;
    if (editData?.templateSettingDTO?.eF4) {
      const decode = decodeURIComponent(editData.templateSettingDTO.eF4);
      const json = JSON.parse(decode);
      console.log("Json", json);
      setcolumnfilter(json);
    }
  }, [editData]);

  useEffect(() => {
    const fetchData1 = () => {
      if (editData) {
        try {
          const data = editData;
          console.log("Fetched data:", data);

          // Assuming templateSettingReportConfigList is an array of objects with rows
          const rows =
            data.templateSettingReportConfigList?.map((item) => ({
              showOrHide: item.showOrHide ?? false,
              columnName: item.columnName ?? "",
              columnDataType: item.columnDataType ?? "",
              columnNameByUser:
                item.columnNameByUser != ""
                  ? item.columnNameByUser
                  : item.columnName,
              columnShowTotalValue:
                item.columnShowTotalValue == "true" ? true : false,
              columnSelectBoxWithSaveBtn: item.columnSelectBoxWithSaveBtn ?? "",
              col1: item.col1.trim(),
              col2: item.col2 ?? "",
              col3: item.col3 ?? "",
              col4: item.col4 ?? "",
              Sub_Query: item.Sub_Query || "",
            })) ?? [];

          // Set formData with the expected structure
          setFormData({ rows });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData1();
  }, [editData]);

  const [isModalOpenFixed, setModalOpenFixed] = useState(false);
  const showOpenFixed = () => {
    setModalOpenFixed(!isModalOpenFixed);
  };

  const hideModalFixed = () => {
    setModalOpenFixed(false);
  };

  // ----------------------------HANDLECOLUMNCREATE--------------------------------

  // -----------------------------------handle csv import--------------------------------
  const [CSVImportModal, setCSVImportModal] = useState(false);
  const handleCSVimport = async () => {
    setCSVImportModal(true);
    // setI
  };

  const handleallclick = (alldata, e) => {
    ;
    console.log(alldata);
    if (e?.target.checked) {
      alldata.map((item, index) => {
        setCheckedItem((prev) => (prev = [...prev, index]));
        formData.rows[index].showOrHide = true;
      });
      console.log(checkedItem);
    } else {
      e != undefined && setCheckedItem([]);
    }
  };

  const [querydata, setQuery] = useState("");
  const handleCheckboxChange = (index) => (event) => {
    const isChecked = event.target.checked;

    ;
    if (inputValues.reportType == "3") {
      if (isChecked && inputValues.reportType == "3") {
        const param =
          'select id from masters1 where lower(name)=lower("@parm")'; // Replace with your dynamic parameter            // setIsChecked(!isChecked);
        formData.rows[index].columnNameByUser = param;
        // setQuery(param);
      } else {
        formData.rows[index].columnNameByUser = "";
      }
    }
    if (inputValues.reportType == "1") {
      if (formData.rows[index].columnDataType != "String" && isChecked) {
        setFormData((prevData) => {
          const updatedRows = [...prevData.rows];

          if (isChecked) {
            // Update the row's columnNameByUser with the query
            // const query = 'select id from masters1 where lower(name)=lower("@parm")';
            // updatedRows[rowIndex].columnNameByUser = query;
            // row.columnDataType = 'String';
            formData.rows[index].columnShowTotalValue = true;
          } else {
            updatedRows[index].columnNameByUser = "";
            // row.columnDataType = editData.templateSettingReportConfigList[rowIndex].columnDataType
            formData.rows[index].columnShowTotalValue = false;
          }
          return { ...prevData, rows: updatedRows };
        });
        // formData.rows[index].columnShowTotalValue = true
      } else {
        setFormData((prevData) => {
          const updatedRows = [...prevData.rows];
          formData.rows[index].columnShowTotalValue = false;
          return { ...prevData, rows: updatedRows };
        });
        // formData.rows[index].columnShowTotalValue = false
      }
    } else {
      setFormData((prevData) => {
        const updatedRows = [...prevData.rows];
        formData.rows[index].columnShowTotalValue = isChecked;
        return { ...prevData, rows: updatedRows };
      });
    }

    // Update the specific row's property
    // formData.rows[index][field] = isChecked;
  };

  console.log("edit data", editData);
  console.log(inputValues);
  console.log(Array(editData?.templateSettingReportConfigList)?.length);
  console.log(checkedItem);

  useEffect(() => {
    console.log(checkedItem);
  }, [checkedItem]);

  useEffect(() => {
    if (formData.rows) {
      handleallclick(formData.rows);
    }
  }, [formData]);

  return (
    <div>
      <PageTabs modelOpen={modelOpen} setSliderCallBack={setSliderCallBack} />
      <div className="panel-heading">
        <div className="panel-head-title">
          <h2 className="panel-title">Report Template Setting</h2>
        </div>
        {/* *******************Top Buttons****************** */}
        <MainButton
          SaveButton={SaveBtn}
          isBtnSetting={false}
          showModal={showModal}
          modelOpen={modelOpen}
          setSliderCallBack={setSliderCallBack}
        />
      </div>

      <div>
        <DateTime />
      </div>
      <div className="content_box">
        <div className="company-info-top-im">
          <div className="tab-head">
            <div id="tabs">
              <div className="tab-content-box">
                <div className="tab-content-1">
                  <div className="company-info-top-right control_flex_m1 item_scroll">
                    <div className="control_radius">
                      <div className="company_info-text-im depart_top">
                        Report Template Setting
                      </div>
                      <div className="company_control">
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              <input
                                className="modify_im_input mode_category1"
                                onChange={handleInputChange}
                                type="text"
                                name="reportName"
                                value={inputValues.reportName}
                                required
                              />
                              <label class="modify_p_text2">Report Name</label>
                            </div>
                          </div>
                        </div>
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              <input
                                className="modify_im_input mode_category1"
                                onChange={handleInputChange}
                                type="text"
                                name="pageLink"
                                value={inputValues.pageLink}
                                required
                              />
                              <label class="modify_p_text2">Page Link</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="company_control">
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2 flex-report-for">
                            <div className="input-box-mok1">
                              <select
                                className="modify_im_input mode_category1"
                                onChange={handleNavigationChange}
                                type="text"
                                name="reportAttachTo"
                                value={inputValues.reportAttachTo}
                                required
                              >
                                <option value="">--Select--</option>
                                {/* <option value="2">Account Master</option>
                                                                <option value="4">Item Master</option>
                                                                <option value="">--Select--</option> */}
                                {options.map((option, index) => (
                                  <option key={index} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                              <label class="modify_lbl_text3">Report For</label>
                            </div>
                            <div className="">
                              <i
                                onClick={showOpenFixed}
                                class="fa-solid fa-circle-plus dm_4"
                              ></i>
                            </div>
                          </div>
                        </div>
                        {isModalOpenFixed && (
                          <div>
                            <div className="modal">
                              <div className="OpticalField-modal Report-template-model">
                                <div className="modal-title-Report">
                                  <h3 className="Report-Fixed-Header">
                                    Add Masters
                                  </h3>
                                  <span
                                    className="close_modal"
                                    onClick={hideModalFixed}
                                  >
                                    &times;
                                  </span>
                                </div>
                                <div className="tab-content-modal">
                                  <div className="company-info-top-modal control_flex_modal item_scroll">
                                    <ModelReportFor
                                      onMasterIdChange={handleMasterIdChange}
                                      onCloseModal={hideModalFixed}
                                      // initialMasterId={currentMasterId}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              <select
                                className="modify_im_input mode_category1"
                                onChange={handleInputChange}
                                type="text"
                                name="reportType"
                                value={inputValues.reportType}
                                required
                              >
                                <option>--Select Report Type--</option>
                                <option value="1">Master List Type</option>
                                {/* <option value="2">Transaction List Type</option> */}
                                <option value="3">Import Export Type</option>
                                <option value="4">
                                  Transaction/Ledger Detail List Type
                                </option>
                              </select>
                              <label class="modify_lbl_text3">
                                Report Type
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="tabs">
                        <div
                          className="tab-btn-box"
                          style={{ justifyContent: "space-between" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              id="firstTab"
                              className={`tab  ${
                                activeTab === 3 ? "active" : ""
                              }`}
                              onClick={() => {
                                handleTabClick(3);
                                showtabs1();
                              }}
                            >
                              Query For Sql
                            </div>
                            <div
                              className={`tab ${
                                activeTab === 1 ? "active" : ""
                              }`}
                              onClick={() => {
                                handleTabClick(1);
                                showtabs2();
                              }}
                            >
                              Query For MySql
                            </div>
                            <div
                              className={`tab ${
                                activeTab === 2 ? "active" : ""
                              }`}
                              onClick={() => {
                                handleTabClick(2);
                                showtabs3();
                              }}
                            >
                              Query For Sqllite
                            </div>
                          </div>
                        </div>
                        <button
                          className={`fill-to-all`}
                          type="button"
                          onClick={(e) => handleClickfillquery(e)}
                          style={{ padding: "0px 8px" }}
                        >
                          Copy To All
                        </button>
                        {showMessage && (
                          <div className="success-message">Copied ✅</div>
                        )}
                        {tabcontent1 && (
                          <div className="Coupon-General-Top">
                            <div>
                              <div className="input-box-tab-head Sms-Text-Box">
                                <div className="input-box-m2">
                                  <textarea
                                    className="modify_im_textarea mode_discharge Report-temp-height"
                                    name="queryForSql"
                                    onChange={handleInputChange}
                                    value={inputValues.queryForSql}
                                    // type="text"
                                    placeholder="Enter SQL query here"
                                    rows="10"
                                    required
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      name="eF1"
                                      style={{ padding: "5px" }}
                                      onChange={handleInputChange}
                                      value={inputValues.eF1}
                                      type="text"
                                      placeholder="Enter Master Type"
                                      rows="10"
                                      disabled={inputValues.reportType != "1"}
                                    />
                                  </div>
                                </div>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      style={{ padding: "5px" }}
                                      name="eF2"
                                      onChange={handleInputChange}
                                      value={inputValues.eF2}
                                      type="text"
                                      placeholder="Enter Order By"
                                      rows="10"
                                      disabled={inputValues.reportType != "1"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              className="execut-btn"
                              onClick={handleFormSubmit}
                            >
                              Execute Query
                            </button>
                          </div>
                        )}

                        {tabcontent2 && (
                          <div className="Coupon-General-Top">
                            <div>
                              <div className="input-box-tab-head Sms-Text-Box">
                                <div className="input-box-m2">
                                  <textarea
                                    className="modify_im_textarea mode_discharge Report-temp-height"
                                    name="queryForMySQL"
                                    onChange={handleInputChange}
                                    value={inputValues.queryForMySQL}
                                    // type="text"
                                    placeholder="Enter MYSQL query here"
                                    rows="10"
                                    required
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      name="eF1"
                                      style={{ padding: "5px" }}
                                      onChange={handleInputChange}
                                      value={inputValues.eF1}
                                      type="text"
                                      placeholder="Enter Master Type"
                                      rows="10"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      style={{ padding: "5px" }}
                                      name="eF2"
                                      onChange={handleInputChange}
                                      value={inputValues.eF2}
                                      type="text"
                                      placeholder="Enter Order By"
                                      rows="10"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              className="execut-btn"
                              onClick={handleFormSubmit}
                            >
                              Execute Query
                            </button>
                          </div>
                        )}
                        {tabcontent3 && (
                          <div className="Coupon-General-Top">
                            <div>
                              <div className="input-box-tab-head Sms-Text-Box">
                                <div className="input-box-m2">
                                  <textarea
                                    className="modify_im_textarea mode_discharge Report-temp-height"
                                    name="queryForSqlite"
                                    onChange={handleInputChange}
                                    value={inputValues.queryForSqlite}
                                    // type="text"
                                    placeholder="Enter SQLLite query here"
                                    rows="10"
                                    required
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      name="eF1"
                                      style={{ padding: "5px" }}
                                      onChange={handleInputChange}
                                      value={inputValues.eF1}
                                      type="text"
                                      placeholder="Enter Master Type"
                                      rows="10"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="input-box-tab-head Sms-Text-Box">
                                  <div
                                    className="input-box-m2"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <input
                                      className="modify_im_textarea mode_discharge Report-temp-height"
                                      style={{ padding: "5px" }}
                                      name="eF2"
                                      onChange={handleInputChange}
                                      value={inputValues.eF2}
                                      type="text"
                                      placeholder="Enter Order By"
                                      rows="10"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              className="execut-btn"
                              onClick={handleFormSubmit}
                            >
                              Execute Query
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="company_info-text-im flex-import-export">
                        <p className={`column_name`}>Column Name</p>
                        {showImportDonwload && (
                          <div className={`div-for-column-header-btn`}>
                            <button
                              className="add-csv-btn"
                              onClick={handleCSVimport}
                            >
                              Import CSV
                            </button>
                            <CsvDownload
                              data={[
                                formData.rows.map(
                                  (item) => item.col1 || item.columnName
                                ),
                              ]}
                              filename={"CSVFile"}
                            />
                          </div>
                        )}
                        {CSVImportModal ? (
                          <ImportCsv
                            option={options}
                            ReportAttachto={inputValues.reportAttachTo}
                            isOpen={CSVImportModal}
                            onClose={setCSVImportModal}
                          />
                        ) : null}
                      </div>

                      <table className="Table-bottom-Column">
                        <thead className="thead-groupmaster">
                          <tr>
                            {FieldName.map((field, index) => {
                              return (
                                <>
                                  <th
                                    className="table-th"
                                    style={{
                                      width: `${
                                        index == 3
                                          ? "25%"
                                          : index == 6
                                          ? "8%"
                                          : null
                                      } `,
                                    }}
                                  >
                                    <div className={`show_hide`}>
                                      {field}
                                      {field == "Show/Hide" && (
                                        <input
                                          onClick={(e) =>
                                            handleallclick(formData.rows, e)
                                          }
                                          checked={
                                            checkedItem.length ===
                                            formData.rows.length
                                          }
                                          className="checkbox-report"
                                          type="checkbox"
                                        />
                                      )}
                                    </div>
                                  </th>
                                </>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {formData.rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              <td style={{ textAlign: "center" }}>
                                <input
                                  className="checkbox-report"
                                  type="checkbox"
                                  defaultChecked={true}
                                  checked={
                                    row.showOrHide &&
                                    checkedItem.includes(rowIndex)
                                  }
                                  onClick={handleCheckboxChangeWrapper(
                                    rowIndex,
                                    "showOrHide"
                                  )}
                                />
                              </td>
                              <td className="TD-center-column">
                                {row.columnName}
                              </td>
                              <td>
                                <input
                                  className="table-input-12"
                                  style={{
                                    marginLeft: "10px",
                                    outline: "none",
                                  }}
                                  type="text"
                                  onChange={handleFormData(
                                    rowIndex,
                                    "columnDataType"
                                  )}
                                  value={row.columnDataType}
                                  name="columnNameByUser"
                                />
                              </td>
                              <td>
                                <textarea
                                  className="table-input-12 input-textarea"
                                  style={{ marginLeft: "10px", padding: "4px" }}
                                  onChange={handleFormData(
                                    rowIndex,
                                    "columnNameByUser"
                                  )}
                                  value={row.columnNameByUser}
                                  name={
                                    FieldValue.includes("Sub-Query")
                                      ? "Sub_Query"
                                      : "columnNameByUser"
                                  }
                                />
                              </td>
                              {inputValues.reportType == 3 && (
                                <td>
                                  <textarea
                                    className="table-input-12 input-textarea"
                                    style={{
                                      marginLeft: "10px",
                                      padding: "4px",
                                    }}
                                    onChange={handleFormData(rowIndex, "col1")}
                                    value={row.col1}
                                    name={"col1"} //report tpye 3 column Name by User
                                  />
                                </td>
                              )}
                              <td style={{ textAlign: "center" }}>
                                <input
                                  className="checkbox-report"
                                  type="checkbox"
                                  checked={row.columnShowTotalValue}
                                  onChange={(e) => {
                                    if (inputValues.reportType == "3") {
                                      setFormData((prevData) => {
                                        const updatedRows = [...prevData.rows];
                                        if (e.target.checked) {
                                          // Update the row's columnNameByUser with the query
                                          const query =
                                            "select id from masters1 where lower(name)=lower('@parm')";
                                          updatedRows[
                                            rowIndex
                                          ].columnNameByUser = query;
                                          row.columnDataType = "String";
                                          row.columnShowTotalValue = true;
                                        } else {
                                          updatedRows[
                                            rowIndex
                                          ].columnNameByUser = "";
                                          if (editData != undefined) {
                                            row.columnDataType =
                                              editData?.templateSettingReportConfigList[
                                                rowIndex
                                              ]?.columnDataType;
                                          } else {
                                            row.columnDataType =
                                              ColumnNames[row.columnName];
                                          }
                                          row.columnShowTotalValue = false;
                                        }
                                        return {
                                          ...prevData,
                                          rows: updatedRows,
                                        };
                                      });
                                    } else {
                                      handleCheckboxChange(
                                        rowIndex,
                                        "columnShowTotalValue"
                                      )(e);
                                    }
                                  }}
                                />
                              </td>

                              {/* <td>
                                {inputValues.reportType == 3 && (
                                  <select
                                    className="table-input-12 select-data-type"
                                    name="col2"
                                    value={row.col2}
                                    onChange={handleFormData(rowIndex, "col2")}
                                  >
                                    <option value="">----Select----</option>
                                    {formData.rows.map((row, index) => (
                                      <option key={index} value={row.col1}>
                                        {row.col1}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </td> */}

                              <td>
                                <select
                                  className="table-input-12 select-data-type"
                                  name="columnSelectBoxWithSaveBtn"
                                  value={row.columnSelectBoxWithSaveBtn || "0"}
                                  onChange={handleFormData(
                                    rowIndex,
                                    "columnSelectBoxWithSaveBtn"
                                  )}
                                >
                                  {FieldValue.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.name} 
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <input
                                  className="table-input-12"
                                  type="number"
                                  style={{ marginLeft: "10px" }}
                                  onChange={handleFormData(rowIndex, "col1")}
                                  value={row.col1}
                                  name="col1"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div onClick={handleAddRow}></div>

                      <div className="company_control">
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              <input
                                className="modify_im_input mode_category1"
                                onChange={handleInputChange}
                                type="number"
                                name="pagination"
                                value={inputValues.pagination}
                                required
                              />
                              <label class="modify_p_text2">Pagination</label>
                            </div>
                          </div>
                        </div>
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1" ref={dropdownRef}>
                              <div
                                className="modify_im_input mode_category1"
                                onClick={toggleDropdown}
                              >
                                <label className="Campaigns-lbl">
                                  Search By Coulmn
                                </label>
                              </div>
                              {isOpen && (
                                <div className="dropdown-list-select">
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("search_ByDate")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.search_ByDate}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "search_ByDate"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("search_ByDate")
                                      }
                                    >
                                      Search By Date
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("srch3")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.srch3}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "search_ByDate"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("search_ByDate")
                                      }
                                    >
                                      Disable CheckBox
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("search_AnyText")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.search_AnyText}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "search_AnyText"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("search_AnyText")
                                      }
                                    >
                                      Search By Any Text
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "search_ByColumn"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.search_ByColumn}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "search_ByColumn"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("search_ByColumn")
                                      }
                                    >
                                      Search By Column
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("orderByButton")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.orderByButton}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "orderByButton"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("orderByButton")
                                      }
                                    >
                                      Order By Button
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("firmNameSelect")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.firmNameSelect}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "firmNameSelect"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("firmNameSelect")
                                      }
                                    >
                                      Firm Name Select
                                    </span>
                                  </div>

                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("srch2")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.srch2}
                                    />
                                    <span
                                      onClick={() => handleOptionClick("srch2")}
                                    >
                                      Show Transaction Type Dropdown{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "billSeriesNameSelect"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.billSeriesNameSelect}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "billSeriesNameSelect"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick(
                                          "billSeriesNameSelect"
                                        )
                                      }
                                    >
                                      Bill Series Name Select
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("printButton")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.printButton}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop("printButton")
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("printButton")
                                      }
                                    >
                                      Print Button
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("excelButton")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.excelButton}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop("excelButton")
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("excelButton")
                                      }
                                    >
                                      Excel Export Button
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("shareButton")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.shareButton}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop("shareButton")
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("shareButton")
                                      }
                                    >
                                      Share Button (Whatsapp/SMS)
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("rowWise_Edit")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.rowWise_Edit}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop("rowWise_Edit")
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("rowWise_Edit")
                                      }
                                    >
                                      Row-wise Edit{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("rowWise_Print")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.rowWise_Print}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "rowWise_Print"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("rowWise_Print")
                                      }
                                    >
                                      Row-wise Print{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "rowWise_Whatsapp"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.rowWise_Whatsapp}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "rowWise_Whatsapp"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("rowWise_Whatsapp")
                                      }
                                    >
                                      Row-wise Whatsapp/SMS{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("rowWise_Delete")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.rowWise_Delete}
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "rowWise_Delete"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick("rowWise_Delete")
                                      }
                                    >
                                      Row-wise Delete{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "rowWise_ArrowForOtherPage"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={
                                        inputValues.rowWise_ArrowForOtherPage
                                      }
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "rowWise_ArrowForOtherPage"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick(
                                          "rowWise_ArrowForOtherPage"
                                        )
                                      }
                                    >
                                      Row-wise Arrow for Navigation/Convert to Another
                                      Page{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "rowWise_TransporterOrOther"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={
                                        inputValues.rowWise_TransporterOrOther
                                      }
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "rowWise_TransporterOrOther"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick(
                                          "rowWise_TransporterOrOther"
                                        )
                                      }
                                    >
                                      Row-wise Button to Open Window (Pay Remaining){" "}
                                    </span>
                                  </div>

                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop("srch1")
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={inputValues.srch1}
                                    />
                                    <span
                                      onClick={() => handleOptionClick("srch1")}
                                    >
                                      Row-wise Double Click Enable{" "}
                                    </span>
                                  </div>
                                  <div
                                    className="dropdown-option"
                                    onClick={() =>
                                      handleCheckboxChangeDrop(
                                        "transactionTypeSelect"
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={
                                        inputValues.transactionTypeSelect
                                      }
                                      // onChange={() =>
                                      //   handleCheckboxChangeDrop(
                                      //     "transactionTypeSelect"
                                      //   )
                                      // }
                                    />
                                    <span
                                      onClick={() =>
                                        handleOptionClick(
                                          "transactionTypeSelect"
                                        )
                                      }
                                    >
                                      Row Wise Transport Details
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="company_control report-navigate-equal">
                        {inputValues.srch1 && (
                          <>
                            <div className="stock-im-dep1">
                              <div className="input-box-Imo1 input-height2 flex-report-for">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) => handleNextPageColumn(e)}
                                    type="text"
                                    name="reportAttachTo"
                                    value={inputValues.eF3}
                                  >
                                    <option value="">--Select--</option>
                                    {options.map((option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Navigate To
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="stock-im-dep1 item-for-equal">
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter1",
                                        "column1"
                                      )
                                    }
                                    type="text"
                                    value={columnfilter.filter1.column1}
                                    name="column-filter"
                                  >
                                    <option value="">--Select--</option>
                                    {formData.rows?.map((row, index) => {
                                      return (
                                        <option key={index} value={row.id}>
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Current Page Column
                                  </label>
                                </div>
                              </div>
                              <span className={`equal`}>=</span>
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter1",
                                        "column2"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter1.column2}
                                  >
                                    <option value="">--Select--</option>
                                    {NextPageColumn?.map((row, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={row.columnName}
                                        >
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Next Page Column
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="stock-im-dep1 item-for-equal">
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter2",
                                        "column1"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter2.column1}
                                  >
                                    <option value="">--Select--</option>
                                    {formData.rows?.map((row, index) => {
                                      return (
                                        <option key={index} value={row.id}>
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Current Page Column
                                  </label>
                                </div>
                              </div>
                              <span className={`equal`}>=</span>
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter2",
                                        "column2"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter2.column2}
                                  >
                                    <option value="">--Select--</option>
                                    {NextPageColumn?.map((row, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={row.columnName}
                                        >
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Next Page Column
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="stock-im-dep1 item-for-equal">
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter3",
                                        "column1"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter3.column1}
                                  >
                                    <option value="">--Select--</option>
                                    {formData.rows?.map((row, index) => {
                                      return (
                                        <option key={index} value={row.id}>
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Current Page Column
                                  </label>
                                </div>
                              </div>
                              <span className={`equal`}>=</span>
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter3",
                                        "column2"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter3.column2}
                                  >
                                    <option value="">--Select--</option>
                                    {NextPageColumn?.map((row, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={row.columnName}
                                        >
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Next Page Column
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="stock-im-dep1 item-for-equal">
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter4",
                                        "column1"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter4.column1}
                                  >
                                    <option value="">--Select--</option>
                                    {formData.rows?.map((row, index) => {
                                      return (
                                        <option key={index} value={row.id}>
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Current Page Column
                                  </label>
                                </div>
                              </div>
                              <span className={`equal`}>=</span>
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter4",
                                        "column2"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter4.column2}
                                  >
                                    <option value="">--Select--</option>
                                    {NextPageColumn?.map((row, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={row.columnName}
                                        >
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Next Page Column
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="stock-im-dep1 item-for-equal">
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter5",
                                        "column1"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter5.column1}
                                  >
                                    <option value="">--Select--</option>
                                    {formData.rows?.map((row, index) => {
                                      return (
                                        <option key={index} value={row.id}>
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Current Page Column
                                  </label>
                                </div>
                              </div>
                              <span className={`equal`}>=</span>
                              <div className="input-box-Imo1 input-height2 flex-report-for field-one-for-filter">
                                <div className="input-box-mok1">
                                  <select
                                    className="modify_im_input mode_category1"
                                    onChange={(e) =>
                                      handleCurrentPageColumn(
                                        e,
                                        "filter5",
                                        "column2"
                                      )
                                    }
                                    type="text"
                                    name="reportAttachTo"
                                    value={columnfilter.filter5.column2}
                                  >
                                    <option value="">--Select--</option>
                                    {NextPageColumn?.map((row, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={row.columnName}
                                        >
                                          {row.columnName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <label class="modify_lbl_text3">
                                    Next Page Column
                                  </label>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="buttom-box">
            <div className="button-btn-1">
              <button className="btn-1">Save</button>
            </div>
            <div className="button-btn-2">
              <button className="btn-2">Reset</button>
            </div>
            <div className="button-btn-3">
              <button className="btn-3">
                <i class="fa-solid fa-gear "></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {alertBoxDelete && (
        <AlertBox
          HeadingTop="DELETE"
          Heading="Are You sure you want to delete this"
          OpenAlertBox={OpenAlertBoxDelete}
          // onYesClick={DeleteLoginTypeConfirm}
        />
      )}
      {alertBox && (
        <AlertBox
          HeadingTop="Saved"
          Heading="Your Template Setting is Saved"
          onYesClick={OpenAlertBox}
          singleButton={true}
          OpenAlertBox={OpenAlertBox}
        />
      )}
      {alertBoxEdit && (
        <AlertBox
          HeadingTop="Updated"
          Heading="Your Template Setting is Updated"
          onYesClick={OpenAlertBoxEdit}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxEdit}
        />
      )}

      {error && (
        <AlertBox
          HeadingTop="All Fields are Required!"
          Heading={error}
          onYesClick={() => setError("")}
          singleButton={true}
          OpenAlertBox={() => setError("")}
          timer={10}
        />
      )}

      {/* {loading && <Loader />} */}
      {/* <MasterListReport inputValues={inputValues}/> */}
    </div>
  );
}

export default ReportTemplateSetting;
